import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FolderService } from "../../../_services/folder.service";
import { ErrorUtil } from "src/app/_utilities/error";
import {ReportService} from "../../../_services/report.service";
import { NgxSpinnerService } from 'ngx-spinner';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';

@Component({
    selector: 'app-report-move',
    templateUrl: './report-move.component.html',
    styleUrls: ['./report-move.component.scss'],
    standalone: false
})
export class ReportMoveComponent implements OnInit {

  folders: any = [];
  selectedFolder: any = null;
  previousFolder: any = null;
  currentFolder: string;
  data: any;
  selectedReportName: string;
  folderList: any  =[];
  firstScreen: boolean = true;
  secondScreen: boolean = false;
  reportDetails: any;
  translate: any;

  constructor(
      public modalRef : BsModalRef, private folderService: FolderService, 
      private errorUtil: ErrorUtil, private reportService: ReportService,
      private spinner: NgxSpinnerService,
      private languageTranslateService: LanguageTranslateService
  ) {
    console.log(this.data, 'data printing in move report')
   }

  ngOnInit(): void {
    console.log(this.data, 'data printing in move modal')
    this.currentFolder = this.data?.folderName;
    this.selectedReportName = this.data?.name;
    this.reportDetails = this.data?.reportDetails;
    this.getFolderList();
    this.languageTranslateService.wordSrc$.subscribe(transData => {
    if (Object.keys(transData).length != 0) {
      this.translate = transData;
    }
  })
  }

  onFolderClick(item: any){
    console.log(item, 'folder clicked')
    console.log(this.selectedFolder);
    //only allow to select the folder which is not the current folder
    if (item.name !== this.currentFolder){
      if (this.selectedFolder?.children?.length > 0){
        //update the folders to display sub folders value
        this.folders = item.children;
        if (!this.previousFolder){
          //save the previous folder value only once
          this.previousFolder = this.selectedFolder;
        }

        this.firstScreen = false;
        this.secondScreen = true;
        //this.selectedFolder = null;
      }
    }
    
  }

  goBackOneFolderAbove(){
    this.folders = this.folderList;
    this.folders = this.folders.filter((f:any) => { return f.name !== 'Favorites' && f.name !== 'Standard Reports' });

    this.selectedFolder = null;
    console.log(this.selectedFolder, 'selected folder')
    console.log(this.previousFolder, 'previous folder')
    this.firstScreen = true;//dont show the back button in first screen
    this.secondScreen = false;
  }

  getFolderList(){
    this.folderService.getFoldersList().subscribe( (res: any) => {
      console.log(res, 'res pringint from GET folders api')
      console.log(this.folders, 'folders in duplicate');
      this.folders = res.body;
      //reports are not allowed to duplicate to Favorites and Standard Reports folders
      this.folders = this.folders.filter((f:any) => { return f.name !== 'Favorites' && f.name !== 'Standard Reports' });
      this.folderList = res.body;
       //by default, the first folder will be selected
      this.selectedFolder = this.folders[0];
      //do not include currentFolder in the folders list
      this.folders = this.folders.filter((f:any) => { return f.name !== this.currentFolder });
    },
    (err: any)=>{
      console.log(err, 'err printing..')
      this.errorUtil.setErrorMessage(
        err.status,
        err.error ? err.error.title : null,
        err.error ? err.error.title : null,
        "error",
        2000
      );
    })
  }

  onMoveSave(){
    let params : any = {
      "id": this.data.id,
      "reportName": this.selectedReportName,
      "description": this.reportDetails?.description,
      "datasetName": this.reportDetails.datasetName,
      "active": true,
     // "offsetValue": 0,
      //"limitValue": 2000,
      "fieldList": this.reportDetails.fieldList,
      "fieldSortCriteria": this.reportDetails.fieldSortCriteria,
      "fieldFilterCriteria": this.reportDetails.fieldFilterCriteria,
      "groupByFieldList": this.reportDetails.groupByFieldList,
      "fieldGroupByCriteria": this.reportDetails.fieldGroupByCriteria,
      "folder": {
        "id": this.selectedFolder.id
      },
      "isFiltersEditable": this.reportDetails.isFiltersEditable,
      "isFavorite": this.reportDetails.isFavorite,
      "isAggregateReport": this.reportDetails.isAggregateReport
    };

    //call update report api by changing the folder id
    this.spinner.show();
    this.reportService.updateReport(params).subscribe((res:any)=>{
      this.spinner.hide();
      if (res.status == 200){
        this.errorUtil.setErrorMessage(
          200,
          this.translate.report.label.singular + ' ' + this.translate.report.validationFE.movedSuccessfully,
          null,
          "success",
          2000
        );
        this.modalRef.hide();
      }
    }, 
    (err:any) =>{
        this.spinner.hide();
      console.log(err, 'error in report update api')
      this.errorUtil.setErrorMessage(
        err.status,
        err.error ? err.error.title : null,
        err.error ? err.error.title : null,
        "error",
        2000
      );
    });
  }

  isRowDisabled(row: any):boolean{
    //disable selection on currentFolder
    return row.name === this.currentFolder;
  }

}
